<div class="login-page">
  <div class="login-content">
    <div class="login-logo-section">
      <img
        [src]="
          helper.darkTheme
            ? 'assets/images/irix_logo_dark.png'
            : 'assets/images/irix_logo.png'
        "
        alt="IRIX"
        class="login-logo"
      />
      <span class="login-tagline">Inteligencia que protege</span>
    </div>

    <mat-card class="login-card" appearance="outlined">
      <h2 class="login-card-title">Elegí una contraseña nueva</h2>

      @if (form) {
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <mat-form-field
            appearance="outline"
            subscriptSizing="fixed"
            class="login-field"
          >
            <mat-label>Contraseña nueva</mat-label>
            <mat-icon matPrefix>key</mat-icon>
            <input
              matInput
              [type]="inputType"
              required
              formControlName="password"
              autocomplete="new-password"
            />
            <button
              irxBotonIcono
              matSuffix
              type="button"
              [tooltip]="
                inputType === 'password'
                  ? 'Mostrar contraseña'
                  : 'Ocultar contraseña'
              "
              (click)="onClickShowPassword()"
            >
              <mat-icon>
                {{ inputType === 'password' ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
            @if (
              form.get('password')?.invalid && form.get('password')?.touched
            ) {
              <mat-error>
                @if (form.get('password')?.errors?.['required']) {
                  Escribí la contraseña nueva
                }
                @if (form.get('password')?.errors?.['minlength']) {
                  La contraseña tiene que tener al menos 6 caracteres
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            subscriptSizing="fixed"
            class="login-field"
          >
            <mat-label>Repetí la contraseña</mat-label>
            <mat-icon matPrefix>key</mat-icon>
            <input
              matInput
              [type]="confirmInputType"
              required
              formControlName="confirmPassword"
              autocomplete="new-password"
            />
            <button
              irxBotonIcono
              matSuffix
              type="button"
              [tooltip]="
                confirmInputType === 'password'
                  ? 'Mostrar contraseña'
                  : 'Ocultar contraseña'
              "
              (click)="onClickShowConfirmPassword()"
            >
              <mat-icon>
                {{
                  confirmInputType === 'password'
                    ? 'visibility'
                    : 'visibility_off'
                }}
              </mat-icon>
            </button>
            @if (
              form.get('confirmPassword')?.invalid &&
              form.get('confirmPassword')?.touched
            ) {
              <mat-error>
                @if (form.get('confirmPassword')?.errors?.['required']) {
                  Volvé a escribir la contraseña nueva
                }
                @if (
                  form.get('confirmPassword')?.errors?.['passwordMismatch']
                ) {
                  Las contraseñas no coinciden
                }
              </mat-error>
            }
          </mat-form-field>

          <button
            irxBoton="principal"
            bloque
            tamano="campo"
            type="submit"
            class="login-button"
            [disabled]="!form.valid || loading.getLoading()"
          >
            <mat-icon>save</mat-icon>
            Cambiar contraseña
          </button>
        </form>
      }

      <div class="back-to-login">
        <button
          irxBoton="secundario"
          bloque
          tamano="campo"
          class="login-button"
          (click)="goBackToLogin()"
        >
          <mat-icon>arrow_back</mat-icon>
          Volver al inicio de sesión
        </button>
      </div>

      <mat-progress-bar
        color="primary"
        [mode]="loading.getLoading() ? 'indeterminate' : 'determinate'"
        class="login-progress"
      ></mat-progress-bar>
    </mat-card>
  </div>

  <footer class="login-footer">
    {{ envService.APP_VERSION }} · &copy; GPE Sistemas 2026
  </footer>
</div>
